module.exports = __webpack_public_path__ + "img/qy_12.png";